"use strict";
require('file?name=[name].[ext]!../index.html');
require('./css/main.css');
//require('../externalLibs/handlebars.runtime.min.js');
require('../externalLibs/jquery-dateFormat.min.js');
require('../externalLibs/typeahead.jquery.min.js');
require("./router.ts");
window["formatTime"] = function (date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    var minutesStr = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutesStr + ampm;
    return strTime;
};
window["substringMatcher"] = function (strs) {
    return function findMatches(q, cb) {
        var matches, substringRegex;
        // an array that will be populated with substring matches
        matches = [];
        // regex used to determine if a string contains the substring `q`
        var substrRegex = new RegExp(q, 'i');
        // iterate through the pool of strings and for any string that
        // contains the substring `q`, add it to the `matches` array
        $.each(strs, function (i, str) {
            if (substrRegex.test(str)) {
                matches.push({ value: str });
            }
        });
        cb(matches);
    };
};
//forms
require("./forms/mainForm.ts");
require("./forms/dutyForm.ts");



/*****************
 ** WEBPACK FOOTER
 ** ./src/client.ts
 ** module id = 0
 ** module chunks = 1
 **/